import React, { useEffect, useState } from "react";
import CommonIcon from "./icons";
const SessionExpiredModal = ({ handleLogout }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        checkSession();
        const interval = setInterval(checkSession, 1000);
        const handleStorageChange = (event) => {
          if (event.key === "isSessionExpiredTAC") {
            checkSession();
          }
        };
        window.addEventListener("storage", handleStorageChange);
        return () => {
          clearInterval(interval);
          window.removeEventListener("storage", handleStorageChange);
        };
      }, []);

    const checkSession = () => {
        const isExpired = localStorage.getItem("isSessionExpiredTAC") === "true";
        setIsOpen(isExpired);
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlaySession">
            <div className=' modal-contentSession form' style={{ height: '400px', width: '600px', textAlign: 'center' }}>
                <CommonIcon fileName={'unauthorize'} />
                <h3 className="access mt-3">Your session has been expired</h3>
                <span>Please login again</span>
                <div className='mt-4' >
                    <button className="btn-fun12 fs-6 login-style-button1" onClick={() => { handleLogout() }}>Ok</button>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
